module.exports = __webpack_public_path__ + "static/media/Facebook_Guide_Chin_Android.bcd454bc.docx";